import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { useField } from "formik";

import "./PhoneField.scss";
import { useTranslation } from "react-i18next";
const PhoneFieldWrapper = ({ name, formik }) => {
  const { t } = useTranslation();
  const [, meta] = useField(name);
  return (
    <div className="phone-field">
      <PhoneInput
        country={"de"}
        value={formik.values[name]}
        onChange={(phone) => {
          formik.setFieldValue(name, phone);
        }}
        placeholder={t("phone-no")}
        containerClass="phoneNumberContainer"
        inputClass="phoneNumberInput"
      />
      {meta && meta.touched && meta.error && (
        <p style={{ color: "#d32f2f" }}>{t("required")}</p>
      )}
    </div>
  );
};

export default PhoneFieldWrapper;
